import { Button, Drawer } from '@chakra-ui/react';
import { currentWallet } from '@cronos-app/wallet';

import { useIsMyAccount } from '../../useIsMyAccount';
import { useProfileDrawer } from '../../useProfileDrawer';
import { SelectChain } from './SelectChain';
import { SocialLinks } from './SocialLinks';

export const Footer = () => {
  const isMyAccount = useIsMyAccount();
  return (
    <Drawer.Footer hidden={!isMyAccount} alignItems="stretch" pt="16px">
      <SocialLinks />
      <SelectChain />
      <Button
        variant="tertiary"
        color="state.error"
        onClick={async () => {
          await currentWallet.disconnect();
          useProfileDrawer.getState().close();
        }}
      >
        Disconnect
      </Button>
    </Drawer.Footer>
  );
};
